import "./career-offers.scss";

import RightArrowIcon from "@frontend/images/icons/RightArrowIcon";
import { resolvePreferredLocale } from "@frontend/js/utils/locale";
import LeftArrowIcon from "@frontend/images/icons/LeftArrowIcon";
import ArrowNextIcon from "@frontend/images/icons/ArrowNextIcon";
import { usePage } from "@inertiajs/react";
import { useRef } from "react";
import useT from "@frontend/js/hooks/useT";

export default function CareerOffers({
    showVacanciesButton = false,
    showSliderControls = false,
    fullWidthMobile = false,
    offerBlocks = [],
    vacanciesPageHref = "",
    vacanciesCount = 0,
}) {
    const { t } = useT("site");
    const sliderRef = useRef(null);

    const handleViewVacancies = () => {
        window.location.href = vacanciesPageHref;
    };

    const scrollSlider = (direction) => {
        const slider = sliderRef.current;
        if (!slider) return;
        const cardWidth = slider.clientWidth / 2 + 8;
        slider.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
    };

    return (
        <div
            className={`careerOffers${fullWidthMobile ? " careerOffers--fullWidthMobile" : ""}`}
        >
            <div className="careerOffers__card careerOffers__card--main">
                <h3>{t("vacancy-offers-title")}</h3>
                {showVacanciesButton && (
                    <button onClick={handleViewVacancies}>
                        {t("vacancy-offers-button-text", {
                            ":vacanciesCount": vacanciesCount,
                        })}{" "}
                        <ArrowNextIcon />
                    </button>
                )}
            </div>
            <div className="careerOffers__sliderWrapper">
                <div className="careerOffers__slider" ref={sliderRef}>
                    {offerBlocks.map((block, index) => (
                        <div className="careerOffers__card" key={index}>
                            <h4>{block.title_for_site}</h4>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: block.content,
                                }}
                            />
                        </div>
                    ))}
                </div>
                <div className="careerOffers__sliderControls">
                    {showSliderControls && (
                        <button
                            type="button"
                            className="careerOffers__sliderControls__btn"
                            onClick={() => scrollSlider(-1)}
                            aria-label="Previous"
                        >
                            <LeftArrowIcon />
                        </button>
                    )}
                    {showSliderControls && (
                        <button
                            type="button"
                            className="careerOffers__sliderControls__btn"
                            onClick={() => scrollSlider(1)}
                            aria-label="Next"
                        >
                            <RightArrowIcon />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
